import { render, staticRenderFns } from "./IndiceDeGestao.vue?vue&type=template&id=28c62e72"
import script from "./IndiceDeGestao.vue?vue&type=script&lang=js"
export * from "./IndiceDeGestao.vue?vue&type=script&lang=js"
import style0 from "./IndiceDeGestao.vue?vue&type=style&index=0&id=28c62e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports